import type { PersistedPrompt } from "schemas";
import { useLiteSiteStore } from "../store";

export function setPrompt(prompt: PersistedPrompt) {
  useLiteSiteStore.setState(({ prompts }) => ({
    prompts: prompts.set(prompt.id, prompt),
  }));
}
